import React from 'react'
import Page from '../components/Page'
import Typography from '../components/Typography'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Form, FormFeedback, FormGroup, FormText, Input, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalBody, ModalFooter, ModalHeader, ButtonGroup } from 'reactstrap'
import { MdEdit, MdFormatListBulleted, MdFlag, MdLanguage, MdHome, MdAdd, MdCameraAlt, MdDone, MdClear, MdFilterList, MdCreate, MdDelete } from 'react-icons/md'
import { Redirect } from 'react-router'
import StorageService from '../services/StorageService'
import axios from '../utils/posAxios'
import PosScheduleForm from '../components/PosScheduleForm'
import PosScheduleSlotForm from '../components/PosScheduleSlotForm'
import PosScheduleModForm from '../components/PosScheduleModForm'
import PosScheduleSlotDayForm from '../components/PosScheduleSlotDayForm'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

class PosScheduleDetailPage extends React.Component {
  access = StorageService.getSession('user_access')
  constructor(props) {
    super(props)
    this.state = {
      isGlobal: true,
      isStore: this.props.history.location.state.isStore,
      role: this.props.history.location.state.store_id ? this.access.store.find(x => x.store_id == this.props.history.location.state.store_id).role : '',
      isEdit: false,
      isCopy: false,
      modal: false,
      slotModal: false,
      confirmModal: false,
      dayModal: false,
      modModal: false,
      redirect: false,
      schedule_id: '',
      name: '',
      advance_days: '',
      advance_min: '',
      location: '',
      allow_onlymod: '',
      pickup: '',
      slot: [],
      mod: [],
      selectedId: '',
      selectedData: '',
      selectedType: '',
      mon: 0,
      tue: 0,
      wed: 0,
      thurs: 0,
      fri: 0,
      sat: 0,
      sun: 0,
    }
  }

  componentDidMount() {
    this.getScheduleDetail()
    //this.getScheduleSlot();
  }

  toggle = () => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit: true,
    })
  }

  toggleslot =
    (action, id, type = null) =>
    () => {
      return this.setState({
        slotModal: !this.state.slotModal,
        isEdit: id != null && action == 'EDIT' ? true : false,
        isCopy: id != null && action == 'COPY' ? true : false,
        selectedId: id,
        selectedType: type,
      })
    }

  togglemod = (action, id) => () => {
    return this.setState({
      modModal: !this.state.modModal,
      isEdit: action === 'EDIT' ? true : false,
      selectedId: id,
    })
  }

  toggleConfirmModal = (type, name, id) => () => {
    return this.setState({
      confirmModal: !this.state.confirmModal,
      selectedData: name,
      selectedId: id,
      selectedType: type,
    })
  }

  toggleDayModal =
    (id = null) =>
    () => {
      if (id == null) {
        return this.setState({
          dayModal: !this.state.dayModal,
        })
      } else {
        let slot = this.state.slot.find(x => x.slot_id == id)
        console.log(slot)
        return this.setState({
          dayModal: !this.state.dayModal,
          selectedId: id,
          mon: slot.mon,
          tue: slot.tue,
          wed: slot.wed,
          thurs: slot.thurs,
          fri: slot.fri,
          sat: slot.sat,
          sun: slot.sun,
        })
      }
    }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    })

    this.setState({
      modal: false,
      slotModal: false,
      modModal: false,
      dayModal: false,
    })

    if (reload) {
      window.location.reload()
    } else {
      this.getScheduleDetail()
      //this.getScheduleSlot();
    }
  }

  getScheduleDetail = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const schedule_id = this.props.match.params.id
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      schedule_id: schedule_id,
    }

    axios
      .post(url + ':3001/v1/schedule/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        this.setState({
          schedule_id: schedule_id,
          advance_days: result.data.advance_days,
          advance_min: result.data.advance_min,
          location: result.data.location,
          allow_onlymod: result.data.allow_onlymod,
          pickup: result.data.pickup,
          name: result.data.name,
        })
      })
      .then(() => {
        if (this.state.allow_onlymod == 1) {
          this.getScheduleDetailSummary()
        } else {
          this.getScheduleSlot()
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getScheduleSlot = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const schedule_id = this.props.match.params.id
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      schedule_id: schedule_id,
    }

    axios
      .post(url + ':3001/v1/schedule/slots', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        this.setState({
          schedule_id: schedule_id,
          slot: result.data.slot,
          mod: result.data.mod,
        })
      })
      .catch(error => {
        alert(error)
      })
  }

  getScheduleDetailSummary = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const schedule_id = this.props.match.params.id
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      schedule_id: schedule_id,
    }

    axios
      .post(url + ':3001/v1/schedule/detail/summary', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        this.setState({
          schedule_id: schedule_id,
          slot: result.data,
        })
      })
      .catch(error => {
        alert(error)
      })
  }

  delete = () => {
    const user = StorageService.getSession('user_info')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      delete_by: user.email,
    }
    let fullUrl
    let redirect = false
    if (this.state.selectedType === 'Schedule') {
      data.schedule_id = this.state.schedule_id
      fullUrl = url + ':3001/v1/schedule/delete'
      redirect = true
    } else if (this.state.selectedType === 'Slot') {
      data.slot_id = this.state.selectedId
      fullUrl = url + ':3001/v1/schedule/slots/delete'
    } else {
      data.slotmod_id = this.state.selectedId
      fullUrl = url + ':3001/v1/schedule/slots/mod/delete'
    }

    axios
      .post(fullUrl, data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: result.message,
            level: 'error',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
          return
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: `${this.state.selectedType} deleted successfully.`,
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({ confirmModal: false })
        if (redirect) {
          setTimeout(() => {
            this.props.history.push('/posstore')
          }, 1000)
        } else {
          if (this.state.allow_onlymod == 1) {
            this.getScheduleDetailSummary()
          } else {
            this.getScheduleSlot()
          }
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />
    }
    let path = [
      { name: 'Stores', active: false, path: '/posstore' },
      {
        name: 'Detail',
        active: false,
        path: '/posstore/' + this.props.history.location.state.store_id,
      },
      {
        name: 'Schedule Detail',
        active: true,
        path: '/posstore/schedule/:id',
      },
    ]
    if (this.props.history.location.state.path == '/posstore') {
      path = [
        { name: 'Store', active: false, path: '/posstore' },
        {
          name: 'Schedule Detail',
          active: true,
          path: '/posstore/schedule/:id',
        },
      ]
    }

    return (
      <Page className="PosScheduleDetailPage" title="Schedule Detail" breadcrumbs={path}>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />

        <Row>
          <Col xl={12} lg={12} md={12}>
            <Card className="ps-card-display">
              <CardHeader className="d-flex align-items-center justify-content-between ps-bg-gradient">
                Schedule Information
                <div className="ps-action-button">
                  <Button className="theme-button  unity-theme-button-transparent" onClick={this.toggle('EDIT', this.state.selectedId)}>
                    <MdEdit />
                    Edit
                  </Button>
                  {(this.state.isStore == false || (this.state.role != '' && this.state.role == 'Admin')) && (
                    <Button className="theme-button  unity-theme-button-transparent" onClick={this.toggleConfirmModal('Schedule', this.state.name, this.state.schedule_id)}>
                      <MdDelete />
                      Delete
                    </Button>
                  )}
                </div>
              </CardHeader>
              <CardBody>
                <Row form>
                  <Col lg={4}>
                    <Label>Name</Label>
                    <p>{this.state.name}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Advance Days</Label>
                    <p>{this.state.advance_days}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Minimum Day</Label>
                    <p>{this.state.advance_min}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Allow Only Date</Label>
                    <p>
                      <span className={'ps-indicator ' + (this.state.allow_onlymod == '1' ? 'on' : 'off')}>{this.state.allow_onlymod == '1' ? 'Yes' : 'No'}</span>
                    </p>
                  </Col>
                  <Col lg={4}>
                    <Label>Location</Label>
                    <p>{this.state.location}</p>
                  </Col>
                  <Col lg={4}>
                    <Label>Delivery Pickup (System will select the earliest available date. User date selection will be disabled)</Label>
                    <p>
                      <span className={'ps-indicator ' + (this.state.pickup == '1' ? 'on' : 'off')}>{this.state.pickup == '1' ? 'Yes' : 'No'}</span>
                    </p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {this.state.allow_onlymod == 1 ? (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card className="ps-card-display main">
                <CardBody>
                  <Row>
                    <Col>
                      <div className="text-left">
                        <Typography className="h5">Slot Modification</Typography>
                      </div>
                    </Col>
                    <Col>
                      <div className="text-right mb-4">
                        <Button className="theme-button theme-button-primary" onClick={this.toggleslot('ADD', null)}>
                          Create
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Table className="ps-table tb-col-5 th-no-wrap ps-responsive-table">
                    <Thead>
                      <Tr>
                        <Th>#Slot</Th>
                        <Th>Start Time</Th>
                        <Th>End Time</Th>
                        <Th>Date</Th>
                        <Th>Mod Slot</Th>
                        <Th>Action</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {this.state.slot.length < 1 && (
                        <Tr>
                          <Td colSpan="6">
                            <div className="ps-empty-data">
                              <div className="empty-content">
                                <MdCreate />
                                <h4>No data to show</h4>
                                <span>Click the Create button to add new slot</span>
                              </div>
                            </div>
                          </Td>
                        </Tr>
                      )}

                      {this.state.slot.length > 0 &&
                        this.state.slot.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <Tr key={item.slot_id}>
                                <Td>#</Td>
                                <Td>{item.starttime}</Td>
                                <Td>{item.endtime}</Td>
                                <Td>{item.date}</Td>
                                <Td>{item.mod_slot}</Td>
                                <Td>
                                  <div className="ps-action-button">
                                    <Button className="theme-button theme-button-secondary" onClick={this.toggleslot('EDIT', item.slotmod_id, 'slotmod_id')}>
                                      Edit
                                    </Button>
                                    <Button className="theme-button theme-button-primary" onClick={this.toggleslot('COPY', item.slotmod_id, 'slotmod_id')}>
                                      Copy
                                    </Button>
                                    <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal('Mod', 'Slot ' + item.slotmod_id, item.slotmod_id)}>
                                      Delete
                                    </Button>
                                  </div>
                                </Td>
                              </Tr>
                            </React.Fragment>
                          )
                        })}
                    </Tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col xl={12} lg={12} md={12}>
              <Card className="ps-card-display main">
                <CardBody>
                  <Row>
                    <Col>
                      <div className="text-left">
                        <Typography className="h5">Slot Modification</Typography>
                      </div>
                    </Col>
                    <Col>
                      <div className="text-right mb-4">
                        <Button className="theme-button theme-button-primary" onClick={this.toggleslot('ADD', null)}>
                          Create
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Table className="ps-table tb-col-5 th-no-wrap ps-responsive-table">
                    <Thead>
                      <Tr>
                        <Th>#Slot</Th>
                        <Th>Start Time</Th>
                        <Th>End Time</Th>
                        <Th>Max Slot</Th>
                        <Th>Action</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {this.state.slot.length < 1 && (
                        <Tr>
                          <Td colSpan="5">
                            <div className="ps-empty-data">
                              <div className="empty-content">
                                <MdCreate />
                                <h4>No data to show</h4>
                                <span>Click the Create button to add new slot</span>
                              </div>
                            </div>
                          </Td>
                        </Tr>
                      )}

                      {this.state.slot.length > 0 &&
                        this.state.slot.map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <Tr key={item.slot_id}>
                                <Td>#</Td>
                                <Td>{item.starttime}</Td>
                                <Td>{item.endtime}</Td>
                                <Td>{item.max_slot}</Td>
                                <Td>
                                  <div className="ps-action-button">
                                    <Button className="theme-button theme-button-primary" onClick={this.togglemod('ADD', item.slot_id)}>
                                      Add
                                    </Button>
                                    <Button className="theme-button theme-button-secondary" onClick={this.toggleslot('EDIT', item.slot_id, 'slot_id')}>
                                      Edit
                                    </Button>
                                    <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal('Slot', 'Slot ' + item.slot_id, item.slot_id)}>
                                      Delete
                                    </Button>
                                    <Button className="theme-button theme-button-dark" onClick={this.toggleDayModal(item.slot_id)}>
                                      Day
                                    </Button>
                                  </div>
                                </Td>
                              </Tr>

                              {this.state.mod.some(x => x.slot_id === item.slot_id) &&
                                this.state.mod
                                  .filter(x => x.slot_id == item.slot_id)
                                  .map(subitem => {
                                    return (
                                      <Tr key={subitem.slotmod_id}>
                                        <Td></Td>
                                        <Td colSpan="2">{subitem.date}</Td>
                                        <Td>{subitem.max_slot}</Td>
                                        <Td>
                                          <div className="ps-action-button">
                                            <Button className="theme-button theme-button-dark" onClick={this.togglemod('EDIT', subitem.slotmod_id)}>
                                              Edit
                                            </Button>
                                            <Button className="theme-button theme-button-primary-light" onClick={this.toggleConfirmModal('Mod', 'Mod ' + subitem.slotmod_id, subitem.slotmod_id)}>
                                              Delete
                                            </Button>
                                          </div>
                                        </Td>
                                      </Tr>
                                    )
                                  })}
                            </React.Fragment>
                          )
                        })}
                    </Tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
        <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className} centered>
          <PosScheduleForm history={this.props.history} onToggleModal={this.toggle} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.slotModal} toggle={this.toggleslot()} className={this.props.className} centered>
          <PosScheduleSlotForm history={this.props.history} onToggleModal={this.toggleslot} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.modModal} toggle={this.togglemod()} className={this.props.className} centered>
          <PosScheduleModForm history={this.props.history} onToggleModal={this.togglemod} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.dayModal} toggle={this.toggleDayModal()} className="modal-sm" centered>
          <PosScheduleSlotDayForm history={this.props.history} onToggleModal={this.toggleDayModal} closeModal={this.closeModal} match={this.props.match} data={this.state} />
        </Modal>

        <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
          <ModalHeader toggle={this.toggleConfirmModal()}>Delete Schedule</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>Are you sure you want to delete this slot ?</p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="theme-button theme-button-secondary" onClick={this.toggleConfirmModal()}>
              No
            </Button>
            <Button className="theme-button theme-button-primary" onClick={() => this.delete()}>
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </Page>
    )
  }
}

export default PosScheduleDetailPage
